import { styled, LinearProgress } from '@mui/material';

export const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
  width: 154,
  height: 24,
  borderRadius: theme.spacing(0.5),
  backgroundColor: theme.palette.custom.neutral[300]
}));
